import React, { useCallback, useState } from 'react'
import useMyFormState from '../../hooks/useMyFormState'
import Cell from '../widgets/Cell';
import './TaskEditor.css'


// -------------------- Static ---------------------

// ---[  matchMe  ]---
//
const matchMe = (input, regex, expectedIndex = 1) => {
  const result = {
    prime: '',
    myGroups: [],
    remaining: ''
  }
  
  if (input) {
    const match =  regex.global ? input.matchAll(regex) || [''] : input.match(regex) || [''];
    // console.debug('matchMe [input: %s] [expectedIndex: %s] [match: %s]', input, expectedIndex, JSON.stringify(match));
    const [...myGroups] = match;
    const namedGroups = match.groups;
    const totalMatch = myGroups[0];
    if (totalMatch) {
      const remaining = input.substring(totalMatch.length);
      result.prime = myGroups[expectedIndex] ? myGroups[expectedIndex] : totalMatch;
      result.myGroups = myGroups;
      result.remaining = remaining;
      result.namedGroups = namedGroups;
    }
  }

  return result;
}

//
// --- Parse Task ---
// 
const parseTask = (text) => {    
  // Subject: Trim any start spaces, then the Subject is anything up to the first colon ':',
  //          then Capture itself if any, to prepare a clean start for the body
  const regexSubject  = /^\s*(?<subject>[^:]+)([:]*)/;
  const regexBody     = /([^\/]+)+/;
  const regexTags     = /\/\s*([^\s\/]+)/g;  // /\/\s*(\S+)/g;
  const regexDue      = /(\d+)([mhdwoy])/;

  const subjectMatch = matchMe(text, regexSubject, 1);
  const subject = subjectMatch.prime;
  
  const bodyMatch = matchMe(subjectMatch.remaining, regexBody, 1);
  const body = bodyMatch.prime;

  const tagsMatch = matchMe(bodyMatch.remaining, regexTags, 0);
  const tags = [];
  for (const tagy of tagsMatch.myGroups) {
    tags.push(tagy[1]);
  }    
  
  const dueMatch = matchMe(tagsMatch.remaining, regexDue, 0);
  const [ , dueCount, dueUnit] = dueMatch.myGroups;

  const result = {
    subject: subject,
    body: body,
    tags:tags,
    dueCount: dueCount,
    dueUnit: dueUnit
  };

  return result;    
}



// -------[  Component:  Task Editor  ]------------
//
export default function TaskEditor({onPopTask, onPopTag = () => {}}) {
  const {errs, handleAddError, handleRemoveError} = useMyFormState();  
  // Only relevant for editing loaded task. Currently not used.
  const [taskText, setTaskText] = useState('');

  // ---[  popEdit  ]---
  //
  const popEdit = useCallback((tmpTaskText, isMandatory = false) => {
    // console.log('[TaskEditor popEdit] [tmpTaskText: %s] [isMandatory: %s]', tmpTaskText, isMandatory);
    
    if (tmpTaskText) {
      const taskData = parseTask(tmpTaskText);
      onPopTask(taskData);
      return Boolean(taskData.subject);  //isValidTaskInfo(taskData);
    }
    else {
      onPopTask(null);
      return true;
    }
  }, [onPopTask]);

  
  // ---[  saveTaskInfo  ]---
  // Todo: what? Relevant only for saving task info directly from the Cell input. (in opposed to popEdit)
  //        Currently not used.
  const saveTaskInfo = useCallback(async (entity, inTaskInfo) => {
    // if (inTaskInfo) {
    //   const taskData = parseTask(inTaskInfo);
    // }
    setTaskText('');
    return true;
  }, []);

  
  // ---  Render  ---

  return (
    <div className='taskEditor'>
      <Cell 
            path='taskInfo' 
            placeholder='subject: description /tag1 /tag2... 5d == number and char estimation: 5m, 4h, 3d, 6w, 2o'
            validateMe={popEdit}  // isValidTaskInfo
            saveMe={saveTaskInfo}
            addError={handleAddError} 
            removeError={handleRemoveError} 
            isLocked={false} 
            tabIx='1'>{taskText}</Cell>
    </div>
  )
}
